'use client';
import { useEffect } from 'react';

// Root error boundary: covers everything outside the (app) group (public share pages, login, newsletter
// read). Phrased as maintenance: the dominant real-world cause is a transient DB outage (e.g. the pinned
// MON 03:00 UTC Cloud SQL window), and "Try again" recovers the moment the DB is back. No Marks wording
// here, visitors on these pages may not be users yet.
export default function RootError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error('[root error boundary]', error);
  }, [error]);

  return (
    <div className="g-wrap">
      <div className="col">
        <div className="glass g-card">
          <div className="h5">Be right back</div>
          <p className="page-sub">We&rsquo;re doing a quick bit of maintenance. Back in a minute or two.</p>
          <button className="modal-cta" onClick={() => reset()}>Try again</button>
        </div>
      </div>
    </div>
  );
}
